import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import Notificaciones from '../../pages/doctor/perfil/Notificaciones'

function ListNotificacion({t, onChangeLoadPage, items}){
    //console.log(items)
    const onChangeLoadPageTrazability = (obj) => {
        onChangeLoadPage(obj);    
    };

    return (
        <Container className="my-5">
            <h2 className="mb-0 title-top">Notificaciones</h2>

            <Card className="shadow-1 mt-3 padding-card-general">
                <Card.Body className="position-relative">  
                <Notificaciones
                    notificaciones={items} 
                    trazabilidad={true}
                    hideStatus={true}
                />                    
                </Card.Body>
            </Card>
            <Row className='mt-3'>
                <Col className="text-right">
                <Button type="button" variant="danger" className="cancelar-buttom" onClick={() => {onChangeLoadPageTrazability({view: "trazabilidad"})}}>Regresar</Button>
                </Col>
            </Row>
        </Container>
    )
    
}

export default withTranslation()(ListNotificacion)